import { Session } from '@/api/Sessions'
import moment from 'moment-timezone'

// Can't use this in cypress tests as it uses `moment-timezone` from the root `node_modules/`
export function mockSession(hour: number, options: Partial<Session> = {}): Partial<Session> {
  return {
    availableCapacity: 10000,
    ...options,
    id: String(hour),
    startMoment: moment(`2030-12-31T${hour}:00Z`).tz('Etc/UTC'),
    endMoment: moment(`2030-12-31T${hour}:30Z`).tz('Etc/UTC'),
  }
}
